import { useEffect, useRef, useState } from "react";
import { File, Info, User } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAgreementData,
  canSelectAgrReference,
  updateAgreementData,
} from "../../api/agreementRequest";
import {
  addAndUpload,
  deleteDocumentList,
  updateAndUpload,
} from "../../api/documentUpload";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import { FORMS, MODULES } from "../../const";
import { formatFromJsonDate } from "../../dateConfig";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../hooks/useUserCompany";
import { errorActions } from "../../store/error-slice";
import DocumentUpload from "../DocumentUpload";
import InfoList from "../InfoList";
import Button from "../input/Button";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import SearchDropdown from "../input/SearchDropdown";
import Tab from "../Tab";
import { agreementValidation } from "../validations/Agreement";

const FORM = FORMS.AGREEMENT.AGR.form;

function AggreementAddComponent({
  editAgreement,
  editMode,
  setUpdateNeeded,
  resetNeeded,
  setResetNeeded,
   onClose,
}) {
  const user = useSelector((state) => state.user);
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.AGREEMENT,
  });

  const [tab, setTab] = useState(firstViableTab);
  const userCompany = useUserCompany();
  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "agreement",
    minTab: 1,
    maxTab: 2,
    module: MODULES.Master,
    section: FORMS.AGREEMENT,
    currentTab: tab,
    authenticated: true,
  });
  const errorState = useSelector((state) => state.error.agreementErrors);
  const dispatch = useDispatch();
  console.log("Edit: ", editAgreement);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const docRef = useRef();
  const referenceRef = useRef();
  const [files, setFiles] = useState([]);
  const isEditAgreementEmpty = Object.keys(editAgreement).length === 0;

  const [agrId, setAgrId] = useState(editAgreement?.agreementResponse?.agrId);

  useEffect(() => {
    setAgrId(editAgreement?.agreementResponse?.agrId);
  }, [editAgreement?.agreementResponse?.agrId]);

  // Form Fields
  const [agreementCode, setAgreementCode] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrCode,
  );
  const [agreementName, setAgreementName] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrName,
  );
  const [agreementDescription, setAgreementDescription] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrDescription,
  );

  const [fromDate, setFromDate] = useState(
    isEditAgreementEmpty
      ? ""
      : editAgreement.agreementResponse?.agrFromDate?.split("T")[0],
  );
  const [toDate, setToDate] = useState(
    isEditAgreementEmpty
      ? ""
      : editAgreement.agreementResponse?.agrToDate?.split("T")[0],
  );
  const [categoryType, setCategoryType] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrCategory,
  );
  const [statusType, setStatusType] = useState(
    isEditAgreementEmpty
      ? 2
      : editAgreement.agreementResponse.agrStatus
        ? editAgreement.agreementResponse.agrStatus
        : 2,
  );

  const [agrOwnerName, setAgrOwnerName] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrOwnerName,
  );

  const [agrOwnerContactNo, setAgrOwnerContactNo] = useState(
    isEditAgreementEmpty
      ? ""
      : editAgreement.agreementResponse.agrOwnerContactNo,
  );

  const [agrOwnerNic, setAgrOwnerNic] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrOwnerNic,
  );

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [categoryObj, setCategoryObj] = useState({});
  const [agrReference, setAgrReference] = useState(
    isEditAgreementEmpty ? "" : editAgreement.agreementResponse.agrReference,
  );

  const [agrReferenceName, setAgrReferenceName] = useState(
    isEditAgreementEmpty
      ? ""
      : editAgreement.agreementResponse.agrReferenceName,
  );

  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const [activeType, setActiveType] = useState(
    isEditAgreementEmpty
      ? 1
      : editAgreement.agreementResponse.agrActive
        ? editAgreement.agreementResponse.agrActive
        : 1,
  );

  // dropdown data

  const [currentErrors, setCurrentErrors] = useState({});
  const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [activeTypeOptions, setActiveTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);

  console.log("category OBJ", categoryObj);
  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new

      const {
        // agreement: agreementOpt = [],
        status = [],
        active = [],
        doc_type: docTypeOpt = [],
        "file_name#6": fileNameOpt = [],
      } = await getBulkDropdownData([
        // { key: "agreement" },
        { key: "status" },
        { key: "active" },
        { key: "doc_type" },
        { key: "file_name", group: "6" },
      ]);

      // setCategoryTypeOptions(agreementOpt);
      setStatusTypeOptions(status);
      setActiveTypeOptions(active);
      setDocumentTypeOptions(docTypeOpt);
      setFileNameOptions(fileNameOpt);

      const catTypeData = await getDropdownData("agreement", "", [
        "keyValue2",
        "keyValue3",
      ]);
      setCategoryTypeOptions(catTypeData);

      if (editMode) {
        setCategoryObj(
          catTypeData?.find(
            (obj) =>
              obj.value === editAgreement?.agreementResponse?.agrCategory,
          ),
        );

        setAgrReferenceName(editAgreement?.agreementResponse?.agrReferenceName);
      }

      setIsLoading(false);
    })();
  }, [editMode]);

  console.log("categoryTypeOptions: ", categoryTypeOptions);

  useEffect(() => {
    if (resetNeeded) {
      defaultAgreement();
      dispatch(errorActions.clearAgreementError());
      setResetNeeded(false);
    }
  }, [resetNeeded]);

  const defaultAgreement = () => {
    setAgreementCode("");
    setCategoryType("");
    setAgreementName("");
    setAgreementDescription("");
    setFromDate("");
    setToDate("");
    setStatusType(2);
    setActiveType(1);
    setAgrOwnerName("");
    setAgrOwnerNic("");
    setAgrOwnerContactNo("");
    setCategoryObj({});
    setAgrReference("");
    setAgrReferenceName("");
    setSearchFieldReset(true);
    referenceRef.current.reset();
  };

  useEffect(() => {
    setCurrentErrors(errorState.agreementErrors);
  }, [errorState]);

  //submit handler
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);

    dispatch(errorActions.clearAgreementError());

    // Create your form data object with the state values
    const requestData = {
      agrCode: agreementCode,
      agrCategory: categoryType,
      agrName: agreementName,
      agrDescription: agreementDescription,
      agrUrl: "",
      agrFromDate: fromDate ? new Date(fromDate).toISOString() : null,
      agrToDate: toDate ? new Date(toDate).toISOString() : null,
      agrStatus: statusType,
      agrActive: activeType,
      agrCompany: company,
      author: user.username,
      agrOwnerName: agrOwnerName,
      agrOwnerNic: agrOwnerNic,
      agrOwnerContactNo: agrOwnerContactNo,
      agrReference: agrReference,
    };
    const agreementValidationResponse = agreementValidation(requestData);
    if (Object.entries(agreementValidationResponse).length > 0) {
      // setCurrentErrors(agreementValidationResponse);
      dispatch(
        errorActions.validateAgreement({
          agreementData: requestData,
        }),
      );
      setIsSubmitLoading(false);
      toast.error("Please fill in all mandatory fields.", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    // Check if toDate is lesser than fromDate
    if (toDate && new Date(toDate) < new Date(fromDate)) {
      dispatch(
        errorActions.addAgreementError({
          form: "agreementErrors",
          key: "agrToDate",
          value: "End date cannot be before start date.",
        }),
      );
      setIsSubmitLoading(false);
      toast.error("End date cannot be before start date.", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    try {
      // Call the addAgreementData from the agreementRequest page
      const documents = docRef.current.getData();
      if (isEditAgreementEmpty) {
        const response = await addAgreementData(requestData);

        let hasUploadErrors = false;
        for (let doc of documents) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append(
            "documentRequest",
            JSON.stringify({
              ...rest,
              docReference: response,
            }),
          );
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        toast.success("Agreement added successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }
        setUpdateNeeded(true);
        onClose();
      } else {
        console.log("ID: ", editAgreement.agreementResponse.agrId);
        const response = await updateAgreementData({
          ...requestData,
          agrId: editAgreement.agreementResponse.agrId,
        });

        console.log(response);
        let hasUploadErrors = false;
        for (let doc of documents.created) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        for (let doc of documents.modified) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await updateAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error updating document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }

        if (documents?.deleted.length > 0) {
          await deleteDocumentList({
            docIdList: documents?.deleted,
          });
          toast.success("Documents deleted successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
        }

        toast.success("Agreement Updated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        setUpdateNeeded(true);
        onClose();
      }

      // Use formData as needed, for example, make an API request
      console.log("Form Data:", requestData);
      // Reset form fields if needed
      setAgreementCode("");
      setCategoryType("");
      setAgreementName("");
      setAgreementDescription("");
      setFromDate("");
      setToDate("");
      setStatusType("2");
      setActiveType("1");
      setAgrOwnerName("");
      setAgrOwnerNic("");
      setAgrOwnerContactNo("");
      setCategoryObj({});
      setAgrReference("");
      docRef.current.resetForm();
      // Display success toast
    } catch (error) {
      console.log("Error adding agreement: ", error);
      if (error?.response?.status === 409) {
        toast.error("Agreement already exists.", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Error adding agreement. Please try again.", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    }
    setIsSubmitLoading(false);
  };

  const nextButtonHandler = () => {
    switch (tab) {
      case 1: {
        const requestData = {
          agrCode: agreementCode,
          agrCategory: categoryType,
          // agrName: agreementName,
          agrDescription: agreementDescription,
          agrUrl: "",
          agrFromDate: fromDate ? new Date(fromDate).toISOString() : null,
          agrToDate: toDate ? new Date(toDate).toISOString() : null,
          agrStatus: statusType,
          agrActive: activeType,
          agrOwnerName: agrOwnerName,
          agrOwnerNic: agrOwnerNic,
          agrOwnerContactNo: agrOwnerContactNo,
          agrReference: agrReference,
        };
        const agrErrors = agreementValidation(requestData);
        if (Object.entries(agrErrors).length > 0) {
          dispatch(
            errorActions.addAgreementErrorObject({
              form: "agreementErrors",
              errors: agrErrors,
            }),
          );
          toast.error("Please fill in all mandatory fields.", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearAgreementError());
        }

        if (toDate && new Date(toDate) < new Date(fromDate)) {
          dispatch(
            errorActions.addAgreementError({
              form: "agreementErrors",
              key: "agrToDate",
              value: "End date cannot be before start date.",
            }),
          );
          toast.error("End date cannot be before start date.", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearAgreementError());
        }
        break;
      }
      default:
    }
    setTab(next());
  };

  console.log("agrReferance", agrReference);

  useEffect(() => {
    (async () => {
      if (!agrReference || agrReference === "" || agrReference === null) return;
      const referenceResponse = await getFieldValuesByTableAndId({
        tableName: "masterdata.tms_m_stakeholder",
        primaryKey: "stk_id",
        fieldNames: "stk_name",
        ids: agrReference,
      });
      const referenceName = referenceResponse[0].field1;

      let name = "";
      const ref = referenceName ?? "";
      const datePart =
        fromDate && toDate
          ? ` (${fromDate} - ${toDate})`
          : fromDate
            ? ` (${fromDate})`
            : toDate
              ? ` (${toDate})`
              : "";

      name = `${ref}${datePart}`;
      if (resetNeeded) {
        name = "";
      }
      setAgreementName(name);
    })();
  }, [agrReference, fromDate, toDate, resetNeeded]);

  console.log("agrReferenceName", agrReferenceName);

  useEffect(() => {
    if (!categoryType || categoryType === "" || categoryType === null) {
      setAgrReference("");
      setAgrReferenceName("");
      setAgreementName("");
      setSearchFieldReset(true);
      referenceRef.current.reset();
    }
    if (!agrReference || agrReference === "" || agrReference === null) {
      setAgreementName("");
    }
  }, [categoryType, agrReference]);

  return (
    <div style={{ width: "60vw" }}>
      <div className="ui top attached tabular menu">
        <Tab
          Icon={Info}
          onClick={() => {
            setTab(1);
          }}
          active={tab === 1}
          label="Agreement"
          authenticated={true}
          form={FORMS.AGREEMENT.AGR_DETAIL.form}
          showMandatory={true}
          isMandatory={true}
          errors={Object.keys(errorState.agreementErrors).length > 0}
        />
        <Tab
          Icon={File}
          onClick={() => {
            setTab(2);
          }}
          active={tab === 2}
          label="Document Upload"
          authenticated={true}
          form={FORMS.AGREEMENT.AGR_DOCUMENT.form}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <form className="ui form">
          <div className="ui segment">
            <h4 className="ui dividing header">Agreement Information</h4>
            <div className="field">
              <div className="field">
                <Input
                  label="Agreement Code"
                  error={currentErrors.agreementCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agreementCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_code"
                  placeholder="Agreement Code"
                  value={agreementCode}
                  onChange={(e) => {
                    setAgreementCode(e.target.value);
                  }}
                  disabled
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Category"
                  required={true}
                  error={currentErrors.agrCategory}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_category"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrCategory: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  clearable
                  placeholder="Category"
                  options={categoryTypeOptions}
                  value={categoryType}
                  style={{ height: "5px" }}
                  onChange={(e, data) => {
                    setCategoryType(data.value);
                    setCategoryObj(
                      categoryTypeOptions?.find(
                        (obj) => obj.value === data.value,
                      ),
                    );
                  }}
                  disabled={categoryTypeOptions?.length === 0}
                />
                <SearchDropdown
                  ref={referenceRef}
                  key={1}
                  required={true}
                  // editMode={editMode}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setAgrReference("");
                  }}
                  multiGrid={true}
                  multiGridCurrentValue={agrReferenceName}
                  onResultSelect={async (data) => {
                    const selectResponse = await canSelectAgrReference(data);
                    if (!selectResponse) {
                      toast.error("Reference already selected", {
                        autoClose: 5000,
                        containerId: "Main",
                      });

                      // setCurrentErrors((prevState) => ({
                      //   ...prevState,
                      //   agrReference: "Reference already selected",
                      // }));

                      dispatch(
                        errorActions.addAgreementError({
                          form: "agreementErrors",
                          key: "agrReference",
                          value: "Reference already selected",
                        }),
                      );
                      setSearchFieldReset(true);
                      referenceRef.current.reset();
                      return;
                    } else {
                      setCurrentErrors((prevState) => ({
                        ...prevState,
                        agrReference: "",
                      }));
                      setAgrReference(data);
                    }
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: categoryObj?.keyValue2,
                    value: categoryObj?.keyValue3,
                  }}
                  label="Reference"
                  disabled={!categoryType || categoryType === ""}
                  error={currentErrors?.agrReference}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrReference: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  // value={agrReference}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="From Date"
                  error={currentErrors.agrFromDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_from_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrFromDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="agr_from_date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  min={
                    editMode ? fromDate : new Date().toISOString().split("T")[0]
                  }
                />
                <Input
                  required={true}
                  label="To Date"
                  error={currentErrors.agrToDate}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_to_date"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrToDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  min={
                    editMode && fromDate
                      ? fromDate
                      : new Date().toISOString().split("T")[0]
                  }
                  type="date"
                  name="agr_to_date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="field">
                <Input
                  required={false}
                  label="Name"
                  error={currentErrors.agrName}
                  companyWise={true}
                  companyCol="agr_company"
                  activeCol="agr_active"
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_name"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_name"
                  value={agreementName}
                  onChange={(e) => setAgreementName(e.target.value)}
                  duplicate={false}
                  tableName="masterdata.tms_m_agreements"
                  primaryKey="agr_id"
                  searchField="agr_name"
                  keyType="S"
                  duplicateErrorMessage="Agreement name already exists"
                  setErrors={setCurrentErrors}
                  errorField="agrName"
                  id={agrId}
                  disabled={true}
                />
              </div>
              <div className="field">
                <Input
                  label="Description"
                  error={currentErrors.agrDescription}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_desc"
                  value={agreementDescription}
                  onChange={(e) => setAgreementDescription(e.target.value)}
                />
              </div>

              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.agrStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { statusType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  clearable
                  options={statusTypeOptions}
                  value={statusType}
                  style={{ height: "5px" }}
                  onChange={(e, data) => {
                    setStatusType(data.value);
                  }}
                />
                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.agrActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_active"
                  authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { activeType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  clearable
                  options={activeTypeOptions}
                  value={activeType}
                  style={{ height: "5px" }}
                  onChange={(e, data) => {
                    setActiveType(data.value);
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Owner Name"
                  error={currentErrors.agrOwnerName}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_owner_name"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrOwnerName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_owner_name"
                  placeholder="Owner Name"
                  value={agrOwnerName}
                  onChange={(e) => {
                    setAgrOwnerName(e.target.value);
                  }}
                />
                <Input
                  required={true}
                  label="Owner NIC"
                  error={currentErrors.agrOwnerNic}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_owner_nic"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrOwnerNic: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_owner_nic"
                  placeholder="Owner NIC"
                  value={agrOwnerNic}
                  onChange={(e) => {
                    setAgrOwnerNic(e.target.value);
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Owner Contact No"
                  pattern="(^[0-9]{10}$)"
                  error={currentErrors.agrOwnerContactNo}
                  module={MODULES.Master}
                  form={FORM}
                  field="agr_owner_contact_no"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { agrOwnerContactNo: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="agr_owner_contact_no"
                  placeholder="Owner Contact No"
                  value={agrOwnerContactNo}
                  onChange={(e) => {
                    setAgrOwnerContactNo(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          {editMode && (
            <InfoList
              title="User Information"
              content={[
                {
                  title: "Created By",
                  value: editAgreement?.agreementResponse?.createdBy
                    ? editAgreement?.agreementResponse?.createdBy
                    : "N/A",
                },
                {
                  title: "Created Date",
                  value: editAgreement?.agreementResponse?.createdDate
                    ? formatFromJsonDate(
                        editAgreement?.agreementResponse?.createdDate,
                      )
                    : "N/A",
                },
                {
                  title: "Last Modified By",
                  value: editAgreement?.agreementResponse?.lastModifiedBy
                    ? editAgreement?.agreementResponse?.lastModifiedBy
                    : "N/A",
                },
                {
                  title: "Last Modified Date",
                  value: editAgreement?.agreementResponse?.lastModifiedDate
                    ? formatFromJsonDate(
                        editAgreement?.agreementResponse?.lastModifiedDate,
                      )
                    : "N/A",
                },
              ]}
              Icon={User}
            />
          )}
        </form>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <DocumentUpload
          opeType={6}
          ref={docRef}
          files={files}
          setFiles={setFiles}
          reference={
            editAgreement
              ? editAgreement.agreementResponse
                ? editAgreement.agreementResponse.agrId
                : null
              : null
          }
          dropdown={{
            documentTypeOptions,
            statusOptions: statusTypeOptions,
            fileNameOptions, //can be changed
            activeOptions: activeTypeOptions,
          }}
          isLoading={isLoading}
          editMode={editMode}
          currentValues={editAgreement.documentResponseList}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {tab > firstViableTab && (
            <Button
              template="back"
              tab={tab - 1}
              module={MODULES.Master}
              section={FORMS.AGREEMENT}
              authenticated={true}
              onClick={() => setTab(prev())}
            />
          )}
          {tab < lastViableTab && (
            <Button
              template="next"
              tab={tab + 1}
              module={MODULES.Master}
              section={FORMS.AGREEMENT}
              authenticated={true}
              onClick={nextButtonHandler}
            />
          )}
          {editMode ? (
            <Button
              type="submit"
              template="create"
              isLoading={isSubmitLoading}
              create={!editMode}
              form={FORMS.AGREEMENT.AGR.form}
              module={MODULES.Master}
              section={FORMS.AGREEMENT}
              authenticated={true}
              editMode={editMode}
              onClick={handleFormSubmit}
            />
          ) : tab === lastViableTab && !isLoading ? (
            <Button
              type="submit"
              template="create"
              isLoading={isSubmitLoading}
              create={!editMode}
              form={FORMS.AGREEMENT.AGR.form}
              module={MODULES.Master}
              section={FORMS.AGREEMENT}
              authenticated={true}
              editMode={editMode}
              onClick={handleFormSubmit}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default AggreementAddComponent;
